export default {"src":"/_next/static/media/calendar-icon.edac84bd.svg","height":25,"width":24};